
export default {
  name: "ModalNovidades",
  props: {
    modalId: {
      type: String,
      default: "modal-novidades",
    },
    pacote: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      marcando: false,
    };
  },
  methods: {
    async marcarComoLido() {
      if (!this.pacote) return;
      this.marcando = true;
      try {
        await this.$http.post("/novidades/marcar-como-lido", { id: this.pacote.id });
      } catch (_) {
        // falha silenciosa — não bloquear o usuário
      } finally {
        this.marcando = false;
        this.$bvModal.hide(this.modalId);
        this.$emit("lido", this.pacote.id);
      }
    },

    verDepois() {
      this.$bvModal.hide(this.modalId);
      this.$emit("fechar");
    },

    formatDate(date) {
      if (!date) return "";
      return this.$moment(date).format("DD/MM/YYYY");
    },

    tipoLabel(tipo) {
      const map = {
        funcionalidade: "Nova função",
        melhoria: "Melhoria",
        correcao: "Correção",
        comunicado: "Comunicado",
        treinamento: "Treinamento",
        importante: "Importante",
      };
      return map[tipo] || tipo;
    },

    tipoBadgeClass(tipo) {
      const map = {
        funcionalidade: "label-light-success",
        melhoria: "label-light-primary",
        correcao: "label-light-warning",
        comunicado: "label-light-info",
        treinamento: "label-light-dark",
        importante: "label-light-danger",
      };
      return map[tipo] || "label-light-secondary";
    },
  },
};
